module.exports = __webpack_public_path__ + "static/17-b875c6e66cf8381063ec83a09b2b8be4.jpg";